import { getImageByOrientation, List, Page } from "@blacknut/javascript-sdk/dist";
import { logD } from "@blacknut/logging/dist";
import {
  Focusable,
  FocusableSectionProps,
  LeaveFor,
} from "@blacknut/spatialnav-sdk/dist";
import React from "react";
import { useInView } from "react-intersection-observer";
import { LOGGING_TAG } from "../../../../utils/Utils";
import styles from "./styles.module.scss";
import FadeInImage from "src/components/FadeInImage/FadeInImage";
import { useOrientation } from "src/utils/OrientationContext";
interface HeroPublisherViewProps
  extends Pick<FocusableSectionProps, "leaveFor" | "disabled"> {
  list: List;
  leaveFor?: LeaveFor;
  onFocus?: (e: React.FocusEvent<HTMLDivElement>) => void;
  page?: Page;
  className?: string;
}

const HeroPublisherView = ({ list, className }: HeroPublisherViewProps) => {
  logD(LOGGING_TAG, "Render hero publisher");
  const [ref, inView] = useInView({
    threshold: 0,
    rootMargin: "33% 0px",
  });
  const { orientation } = useOrientation();

  const imgBanner = getImageByOrientation(orientation, list.imgBackground ?? []);
  return (
    <div ref={ref} className={className}>
      {(inView || process.env.NODE_ENV === "test") && (
        <Focusable className={styles.container}>
          <FadeInImage image={imgBanner} className={styles.image} />
        </Focusable>
      )}
    </div>
  );
};

export default HeroPublisherView;
